import React from 'react';

var SharePackagePopup = React.createClass({
	getInitialState: function(){
		return { 	receiver :  [], 
					currentData: [], 
					message: "", 
					messageLink: "Include a message",
					messageShow: false,
					errClas: "",
					data: [],
					value: "", 
					suggestions: [], 
					i: -1 }
	},
	componentDidMount: function(){
		this.setState({currentData: this.props.data});
	},
	componentWillReceiveProps: function(nextProps){
		if(nextProps.accountsList && typeof nextProps.accountsList === "object" && nextProps.accountsList.length > 0){
			var value = this.state.value;
			var suggestion = nextProps.accountsList.filter((valuee, index) => {
				return value.length >= 2 && valuee.user_name.indexOf(value.toLowerCase()) > -1 && valuee.verified;
			});
			for (var i in suggestion){
				suggestion[i]["active"] = false;
			}

			if(suggestion.length > 0){
				if(this.state.i === -1){
					suggestion[this.state.i+1]["active"] = true;
	        		this.setState({i: this.state.i+1});
				}
			}
			this.setState({suggestions: suggestion});
		}
	},
	handleTextChange: function(value){
		this.setState({value: value , errClas: ""});

		if(value.length === 2){
			this.props.searchAccounts(value.toLowerCase());
		} else if(value.length >= 3 && typeof this.props.accountsList == "object" && this.props.accountsList.length > 0) {
			var suggestion = this.props.accountsList.filter((valuee, index) => {
				return value.length >= 3 && valuee.user_name.indexOf(value.toLowerCase()) > -1 && valuee.verified;
			});
			for (var i in suggestion){
				suggestion[i]["active"] = false;
			}

			if(suggestion.length > 0){
				if(this.state.i === -1){
					suggestion[this.state.i+1]["active"] = true;
	        		this.setState({i: this.state.i+1});
				}
			}
			this.setState({suggestions: suggestion});
		}
	},
	handleCancelClick: function(){
		this.props.sharePackage("close");
	},
	handleCrossClick: function(id){
		this.props.revoke("open", id);
	},
	handleShareClick: function(){
		if(this.state.receiver.length <= 0 || this.state.value !== ""){
			this.setState({errClas: "field__error--input"})			
		} else {
			this.props.sharePackage("submit", this.state.receiver, this.state.message);
		}
	},
	revoke: function(action, revokeId){
		this.props.revoke(action, revokeId);
	},
	addReceiver: function (value) {
		/*add in receiver and remove from current data*/
		for(var i in this.state.receiver){
			if(this.state.receiver[i] === value){
				this.setState({value: "", suggestions: [], i: -1});
				return;		
			}
		}
		var temp = this.state.receiver;
		temp.push (value)
		this.setState ({'receiver' :  temp});
		this.setState({errClas: ""});
		this.setState({value: "", suggestions: [], i: -1});

	},
	handleRemoveMail: function(value){
		/*remove from receiver and add in curent data */
		var temp = this.state.receiver;
		for (var i in temp){
			if (temp[i] === value){
				temp.splice(i, 1);
			}
		}
		this.setState({receiver: temp});
	},
	cloneObject: function cloneObject(obj) {
	    var copy;

	    // Handle the 3 simple types, and null or undefined
	    if (null == obj || "object" != typeof obj) return obj;

	    // Handle Date
	    if (obj instanceof Date) {
	        copy = new Date();
	        copy.setTime(obj.getTime());
	        return copy;
	    }

	    // Handle Array
	    if (obj instanceof Array) {
	        copy = [];
	        for (var i = 0, len = obj.length; i < len; i++) {
	            copy[i] = cloneObject(obj[i]);
	        }
	        return copy;
	    }

	    // Handle Object
	    if (obj instanceof Object) {
	        copy = {};
	        for (var attr in obj) {
	            if (obj.hasOwnProperty(attr)) copy[attr] = cloneObject(obj[attr]);
	        }
	        return copy;
	    }

	    throw new Error("Unable to copy obj! Its type isn't supported.");
	},
	handleMessageLinkClick: function(){
		if(this.state.messageShow){
			this.setState({messageLink: "Include a message", messageShow: false, message: ""});
		} else {
			this.setState({messageLink: "Discard message", messageShow: true});
		}

	},
	handleMessageChange: function(e){
		this.setState({message: e.target.value})
	},
	checkValidEmail: function(email){
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	},
	handleKeyDown: function(event){
		var suggestions = this.state.suggestions;

		if(event.keyCode === 9){
			event.preventDefault();
		}

		if(event.keyCode == 40){  // for down arrow
			event.preventDefault();
			if(suggestions.length > this.state.i+1){
				suggestions[this.state.i+1]["active"] = true;
        		this.setState({i: this.state.i+1});
			}
			if(this.state.i >= 0) {
				suggestions[this.state.i]["active"] = false;
			}
			this.setState({"suggestions": suggestions});
        }

        if(event.keyCode == 38 && this.state.i > 0){  // for up arrow
        	event.preventDefault();
			suggestions[this.state.i-1]["active"] = true;
			suggestions[this.state.i]["active"]   = false;
    		this.setState({i: this.state.i-1, suggestions: suggestions});
        }

        if(this.checkValidEmail(this.state.value) && event.keyCode === 9){
        	event.preventDefault();
        	this.addReceiver(this.state.value.toLowerCase());
        	this.setState({value: "", suggestions: [], i: -1});
        }

        if(event.keyCode == 9 && suggestions.length > 0){ // for tab key
        	event.preventDefault();
        	this.addReceiver (suggestions[this.state.i].user_name);
        	this.setState({value: "", suggestions: [], i: -1});
        }

        if(event.keyCode == 13 && suggestions.length > 0){  // for enter key
        	event.preventDefault();
        	if(this.state.i !== -1){
        		this.addReceiver (suggestions[this.state.i].user_name);	
        	}
	        this.setState({value: "", suggestions: [], i: -1});
        }

        if(event.keyCode === 46 && this.state.value.length <= 0){    // for delete key
        	this.handleRemoveMail(this.state.receiver[this.state.receiver.length-1])
        }
	},
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	resendInviteShare: function(email){
		var body = {"action": "share"};
		if(this.checkValidEmail(email)){
			body["email"] = email;
		} else {
			body["accountSlug"] = email;
		}
		this.props.resendInvite(body);
	},
	render: function(){
		return (
			<div className="modal__mask" onClick = {this.handleCancelClick}>
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Share Package “{this.props.themeName}”</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCancelClick}>
				    	<i className="fa  fa-close"> </i>
				    </a> 
				  </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>Sharing grants other Blended accounts <a href="javascript:void(0)" className="tooltip__container">read only <span className="tooltip tooltip--top tooltip--lg">Means the shared user is only granted the ability to view/preview the shared package. User will have to clone it in order to edit. You have shared this package with {this.props.data.length} users.</span></a> access to this package. You will still control who gets access.</p>
				    </div>
				    <SharedPeople revoke = {this.revoke}
				                  themeName = {this.props.themeName}
				                  data = {this.props.data}
				                  handleCrossClick = {this.handleCrossClick}
				                  resendInviteShare = {this.resendInviteShare} />
				    <div className="form__row clearfix">
				      <div className="form__cell">
				        <label><strong>Share with more people:</strong></label>
				        {this.state.errClas !== "" ?
				        <p className ="field__error--text">Please enter a valid username or email.</p> : null}
				      </div>
				      <AddEmailField data = {this.props.data}
				      				 receiver = {this.state.receiver}
				      				 addReceiver =  {this.addReceiver}
				      				 handleRemoveMail = {this.handleRemoveMail}
				      				 currentData = {this.state.currentData}
				      				 errClas= {this.state.errClas}
				      				 value = {this.state.value}
				      				 suggestions = {this.state.suggestions}
				      				 i = {this.state.i}
				      				 handleKeyDown = {this.handleKeyDown}
				      				 handleTextChange = {this.handleTextChange} />
				     <div className="form__cell"> 
				      	<a href="javascript:void(0)" className="hot__link"  onClick= {this.handleMessageLinkClick}>{this.state.messageLink}</a> 
				      </div>
				      { this.state.messageShow ?
				      <div className="form__cell">
				        <textarea  	onChange = {this.handleMessageChange} 
				        			value = {this.state.message} 
				        			placeholder = "Include a message" />
				      </div> : null }
				    </div>
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-very_light" onClick = {this.handleCancelClick}>Cancel</button>
				      <button className="btn__lg bg-dark" onClick = {this.handleShareClick}>Share</button>
				    </div>
				  </div>
				</div>
			</div>
			);
	}

});

var SharedPeople = React.createClass({
	handleCrossClick: function(id){
		this.props.handleCrossClick(id);
	},
	handleResendInviteClick: function(email){
		this.props.resendInviteShare(email);
	},
	render: function(){
		var NoOfPeople = this.props.data.length;
		var data = this.props.data;
		var result = [];
		for (var i in data){
			if(data[i]["email"] && data[i]["shared_account"] && !data[i]["pending"] && data[i]["share_via_email"]){
					// invite via email
					result.push(<li className="share__item" key = {i}>
			            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title="" local/></div>
			            <div className="share__cell share__item--name"><strong>{data[i]["shared_account"]}</strong><span>invite via email <a href="javascript:void(0)">{data[i]["email"]}</a></span> </div>
			            <div className="share__cell share__item--remove" onClick = {this.handleCrossClick.bind(this, data[i]["shared_account"])}><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
			        </li>);

			} else if(data[i]["email"] && data[i]["shared_account"] && !data[i]["pending"]){
					// ONLY NAME
					result.push(<li className="share__item" key = {i}>
			            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title="" local/></div>
			            <div className="share__cell share__item--name"><strong>{data[i]["shared_account"]}</strong></div>
			            <div className="share__cell share__item--remove" onClick = {this.handleCrossClick.bind(this, data[i]["shared_account"])}><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
			        </li>);

			} else if(data[i]["email"] && !data[i]["shared_account"] && data[i]["pending"]){
					// email with resend invite
					result.push(<li className="share__item" key = {i}>
			            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title="" local/></div>
			            <div className="share__cell share__item--name"><strong>{data[i]["email"]}</strong><span><a href="javascript:void(0)" onClick = {this.handleResendInviteClick.bind(this, data[i]["email"])}>Resend invite</a></span></div>
			            <div className="share__cell share__item--remove" onClick = {this.handleCrossClick.bind(this, data[i]["email"])}><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
			        </li>);

			} else if(data[i]["email"] && data[i]["shared_account"] && data[i]["pending"]){
					// name with resend invite
					result.push(<li className="share__item" key = {i}>
			            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title="" local/></div>
			            <div className="share__cell share__item--name"><strong>{data[i]["shared_account"]}</strong><span><a href="javascript:void(0)" onClick = {this.handleResendInviteClick.bind(this, data[i]["email"])}>Resend invite</a></span></div>
			            <div className="share__cell share__item--remove" onClick = {this.handleCrossClick.bind(this, data[i]["shared_account"])}><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
			        </li>);
			}
		}
		return(
			<div>
				<div className="form__row clearfix">
					      <p>You have shared <strong>"{this.props.themeName}"</strong> with {NoOfPeople} people.</p>
				</div>
				{NoOfPeople > 0 ?
				 <div className="form__row clearfix">
				      <div className="share__container">
				        <ul className="share__list list-unstyled">
				         {result}
				         {/* <li className="share__item">
				            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title=""/></div>
				            <div className="share__cell share__item--name"><strong>romanblended</strong> <span>invite via email <a href="javascript:void(0)">roman@dbmonline.net</a></span></div>
				            <div className="share__cell share__item--remove"><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
				          </li>
				          <li className="share__item">
				            <div className="share__cell share__item--img"><img src="images/share_to_arg.png" alt="" title=""/></div>
				            <div className="share__cell share__item--name"><strong>args2323</strong> </div>
				            <div className="share__cell share__item--remove"><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
				          </li>
				          <li className="share__item">
				            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title=""/></div>
				            <div className="share__cell share__item--name"><strong>eduardo@dbmonline.net</strong> <span><a href="javascript:void(0)">Resend invite</a></span></div>
				            <div className="share__cell share__item--remove"><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
				          </li>
				          <li className="share__item">
				            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title=""/></div>
				            <div className="share__cell share__item--name"><strong>abid@cognam.com</strong> <a href="javascript:void(0)">Resend invite</a></div>
				            <div className="share__cell share__item--remove"><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
				          </li>
				          <li className="share__item">
				            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title=""/></div>
				            <div className="share__cell share__item--name"><strong>ashrivastava@cognam.com</strong></div>
				            <div className="share__cell share__item--remove"><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
				          </li>
				          <li className="share__item">
				            <div className="share__cell share__item--img"><img src="images/share_to_no_img.png" alt="" title=""/></div>
				            <div className="share__cell share__item--name"><strong>srawat@cognam.com</strong></div>
				            <div className="share__cell share__item--remove"><a href="javascript:void(0)"><i className="fa fa-times-circle"> </i></a></div>
				          </li> */ }
				        </ul>
				      </div>
				    </div> : null}
			    </div>
		);
	}
});


var AddEmailField = React.createClass({
	handleTextChange: function(e){
		this.props.handleTextChange(e.target.value)
	},
	handleMailClick: function(value){
		this.props.addReceiver (value);
	},
	handleRemoveMail: function(value){
		this.props.handleRemoveMail(value);
	},
	render: function(){
		var suggestions = [];
		if(this.props.value.length >= 3){
			this.props.suggestions.map(function(value, index){
				var user_name = value.user_name.split(this.props.value.toLowerCase());
				var result = [], flag = 0;
				if(user_name.length > 1){  // for user_name
					for (var i in user_name){
					   if(user_name[i] === "" && flag === 0){
					      result.push(<strong key = {i + value}>{this.props.value.toLowerCase()}</strong>);
					      flag = 1;
					   } else {
					      result.push(user_name[i].toLowerCase());
					   }
					}
					if(flag === 0){
						var temp = result[1];
						result[1] = <strong key = {value + 1}>{this.props.value.toLowerCase()}</strong>;
						result.push(temp);
					}
				
					var suggestionActiveclass = "suggest__item"
					if (value["active"]){
						suggestionActiveclass = "suggest__item active";
					}
					suggestions.push(<li className={suggestionActiveclass} key= {index+ value.user_name} onClick = {this.handleMailClick.bind(this, value.user_name)} >
		       	 				<div className="suggest__cell suggest__cell--img">
		        					<img src="images/add__item_no_img.png" alt="" title="" local/>
		        				</div>
		        				<div className="suggest__cell suggest__cell--name">{result}</div>
		      				</li>)
				}
			}, this);
		}
		if(this.props.suggestions.length <= 0 && this.props.value.length >= 3 ){
			suggestions = 	<li className="suggest__item active">
	       	 					<div className="suggest__cell suggest__cell--img">
	        						<img src="images/add__item_no_img.png" alt="" title="" local/>
	        					</div>
	        					<div className="suggest__cell suggest__cell--name"><strong>{this.props.value}</strong>{/*rr@gmail.com*/}</div>
	      					</li>
		}
		var mails = this.props.receiver.map(function(value, index){
			return (
					<div className="add__email__list" key = {value + index}>
		            	<div className="add__list">
		              		<div className="add__item">
		                		<div className="item__cell item__cell--img"><img src="images/add__item_no_img.png" alt="" title="" local/></div>
		                		<div className="item__cell item__cell--name">{value}</div>
		                		<div className="item__cell item__cell--remove" onClick = {this.handleRemoveMail.bind(this, value)}><a href="javascript:void(0)"><i className="fa fa-close"> </i></a></div>
		              		</div>
		            	</div>
		          	</div>
				);
		}, this);
		return(
			<div className="form__cell">
				<div className = {this.props.errClas}>
					{this.props.receiver.length > 0 || this.props.value != ""  ?
						<div className="add__emails clearfix"> 
					        {mails}
					        <div className="add__emails__field">
					          	<input type="text" autoFocus  	placeholder= "Add More People..."
					          									onKeyDown = {this.props.handleKeyDown} 
					          								 	value = {this.props.value} 
					          								 	onChange = {this.handleTextChange} />
					          	{ suggestions.length > 0 ?
						          	<div className="suggest__emails">
						            	<ul className="suggest__list list-unstyled">
						            		{suggestions}
						            	</ul>
						          	</div> : null
					      		}	
					        </div>
				        </div> : <input type= "text" placeholder = "Enter usernames or emails" 	autoFocus 	
				        																		value = {this.props.value} 
				        																		onChange = {this.handleTextChange} /> }
			    </div>
		    </div>
		);
	}
})


export {SharePackagePopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/SharePackagePopup.jsx
 **/